import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ErrorService } from './error.service';
import { Constants } from '../../assets/constants';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(private http: HttpClient, private errorService: ErrorService) {}

  getPDF(fundId: any): Observable<any> {
    return this.http
      .get(
        environment.apiUrlbase +
          environment.endPoints.memberInfo +
          '/' +
          fundId +
          environment.endPoints.eacDownload,
        { responseType: 'blob' }
      )
      .pipe(
        map((responseData) => {
          let response: any = {};
          response = responseData;
          return response;
        })
      );
  }

  emailPDF(fundId: any, emailAddress: any): Observable<any> {
    return this.http
      .post(
        environment.apiUrlbase +
          environment.endPoints.memberInfo +
          '/' +
          fundId +
          environment.endPoints.eacEmail,
        {
          emailAddress: emailAddress,
        }
      )
      .pipe(
        map((responseData) => {
          let response: any = {};
          response = responseData;
          return response;
        }),
        catchError((errorRes) => {
          console.error(Constants.emailPdfErrorMessage, errorRes);
          if (errorRes.error) {
            this.errorService.openErrorPopup(errorRes.error);
          } else {
            this.errorService.openErrorPopup(
              Constants.emailPdfErrorMessageRetry
            );
          }
          return throwError(errorRes);
        })
      );
  }
}
